import {
  colorAccent,
  colorBrandOnDark,
  colorBrandOnLight,
  colorBrandBgDark,
  colorBrandBgLight,
} from "@adva/tokens";

export type BrandColor = "dark" | "light" | "accent";
export type BrandVariant = "transparent" | "solid";

// Ink color — the color of the A-glyph / wordmark strokes.
// "dark" renders light ink (for placement on dark surfaces),
// "light" renders dark ink (for placement on light surfaces),
// "accent" uses the brand accent regardless of placement.
export const INK_COLOR: Record<BrandColor, string> = {
  dark: colorBrandOnDark,
  light: colorBrandOnLight,
  accent: colorAccent,
};

// Background color for the `variant="solid"` tile. Mirrors the SVG masters:
// a dark-ink variant sits on a light tile and a light-ink variant sits on a
// dark tile; the accent variant takes the dark tile.
export const TILE_COLOR: Record<BrandColor, string> = {
  dark: colorBrandBgDark,
  light: colorBrandBgLight,
  accent: colorBrandBgDark,
};
